export function formatDate(value) {
  if (!value) return '—';
  const str = String(value);
  return str.includes('T') ? str.slice(0, 10) : str;
}

export function parseFeatures(features) {
  if (!features) return [];
  if (Array.isArray(features)) return features;
  return String(features)
    .split('\n')
    .map((line) => line.trim())
    .filter(Boolean);
}

export function monthKey(dateStr) {
  const d = new Date(`${dateStr}T00:00:00`);
  if (Number.isNaN(d.getTime())) return '';
  return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}`;
}

export function monthLabel(key) {
  const [year, month] = key.split('-');
  const d = new Date(Number(year), Number(month) - 1, 1);
  return d.toLocaleString('en-US', { month: 'short', year: 'numeric' });
}

export function lastNMonthKeys(n = 7) {
  const keys = [];
  const now = new Date();
  for (let i = n - 1; i >= 0; i -= 1) {
    const d = new Date(now.getFullYear(), now.getMonth() - i, 1);
    keys.push(`${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}`);
  }
  return keys;
}
